import constants from 'common/constants'

import {
  DELETE_COLLEGE_COUNSELLING_DOCUMENT,
  DELETE_COLLEGE_COUNSELLING_PORTFOLIO,
  DOWNLOAD_COLLEGE_COUNSELLING_APPLICATION_PDF,
  DOWNLOAD_COLLEGE_COUNSELLING_RECOMMENDATION,
  DOWNLOAD_COLLEGE_COUNSELLING_RECOMMENDATION_WORD,
  GET_COLLEGE_COUNSELLING_DOCUMENT_TYPES,
  GET_COLLEGE_COUNSELLING_PORTFOLIO,
  GET_COLLEGE_COUNSELLING_PORTFOLIOS,
  GET_COLLEGE_COUNSELLING_PORTFOLIO_STATS,
  GET_COLLEGE_COUNSELLING_TEACHERS,
  GET_COLLEGE_COUNSELLING_TEACHER_REQUESTS,
  GET_EXTERNAL_RECOMMENDATION_REQUEST,
  GET_MY_COLLEGE_COUNSELLING_PORTFOLIO,
  GET_MY_COLLEGE_COUNSELLING_PORTFOLIOS,
  REJECT_COLLEGE_COUNSELLING_RECOMMENDATION_REQUEST,
  RETURN_COLLEGE_COUNSELLING_PORTFOLIO,
  SAVE_COLLEGE_COUNSELLING_ACADEMICS,
  SAVE_COLLEGE_COUNSELLING_DESTINATIONS,
  SAVE_COLLEGE_COUNSELLING_DOCUMENT,
  SAVE_COLLEGE_COUNSELLING_RECOMMENDATION_DRAFT,
  SAVE_COLLEGE_COUNSELLING_SECTION,
  SEND_COLLEGE_COUNSELLING_RECOMMENDATION_REQUEST,
  SET_COLLEGE_COUNSELLING_PORTFOLIO_STATUS,
  START_COLLEGE_COUNSELLING_APPLICATION,
  SUBMIT_COLLEGE_COUNSELLING_PORTFOLIO,
  SUBMIT_COLLEGE_COUNSELLING_RECOMMENDATION,
  SUBMIT_EXTERNAL_RECOMMENDATION,
} from './ActionTypes/ApiActionTypes'

export const getMyCollegeCounsellingPortfolio = (onSuccess, onFailure) => {
  return {
    type: GET_MY_COLLEGE_COUNSELLING_PORTFOLIO,
    payload: {
      apiUrl: constants.api_college_counselling_my_portfolio,
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getMyCollegeCounsellingPortfolios = (onSuccess, onFailure) => {
  return {
    type: GET_MY_COLLEGE_COUNSELLING_PORTFOLIOS,
    payload: {
      apiUrl: constants.api_college_counselling_my_portfolios,
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const startCollegeCounsellingApplication = (onSuccess, onFailure) => {
  return {
    type: START_COLLEGE_COUNSELLING_APPLICATION,
    payload: {
      apiUrl: constants.api_college_counselling_start,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getCollegeCounsellingPortfolioStats = (onSuccess, onFailure) => {
  return {
    type: GET_COLLEGE_COUNSELLING_PORTFOLIO_STATS,
    payload: {
      apiUrl: constants.api_college_counselling_stats,
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getCollegeCounsellingTeachers = (onSuccess, onFailure) => {
  return {
    type: GET_COLLEGE_COUNSELLING_TEACHERS,
    payload: {
      apiUrl: constants.api_college_counselling_teachers,
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getCollegeCounsellingTeacherRequests = (data, onSuccess, onFailure) => {
  return {
    type: GET_COLLEGE_COUNSELLING_TEACHER_REQUESTS,
    payload: {
      apiUrl: constants.api_college_counselling_teacher_requests,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

/**
 * External: the recommendation request behind an emailed link.
 *
 * Called by an external teacher who is not logged in. No auth header is needed
 * — SagaHelper only attaches one when a session exists — and the tenant comes
 * from the portal's own hostname, so the link must be opened on the school's
 * domain.
 */
export const getExternalRecommendationRequest = (token, onSuccess, onFailure) => {
  return {
    type: GET_EXTERNAL_RECOMMENDATION_REQUEST,
    payload: {
      apiUrl: constants.api_college_counselling_external_recommendation(token),
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

/** External: submits the external teacher's recommendation. Allowed once. */
export const submitExternalRecommendation = (token, data, onSuccess, onFailure) => {
  return {
    type: SUBMIT_EXTERNAL_RECOMMENDATION,
    payload: {
      apiUrl: constants.api_college_counselling_external_recommendation(token),
      getString: '',
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const rejectCollegeCounsellingRecommendationRequest = (id, data, onSuccess, onFailure) => {
  return {
    type: REJECT_COLLEGE_COUNSELLING_RECOMMENDATION_REQUEST,
    payload: {
      apiUrl: constants.api_college_counselling_reject_recommendation(id),
      getString: '',
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const sendCollegeCounsellingRecommendationRequest = (id, data, onSuccess, onFailure) => {
  return {
    type: SEND_COLLEGE_COUNSELLING_RECOMMENDATION_REQUEST,
    payload: {
      apiUrl: constants.api_college_counselling_send_recommendation(id),
      getString: '',
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

// Same JSON {url} response as the PDF: the API uploads the .docx and hands back
// a link. It used to return the bytes and the saga saved them from a `blob:`
// URL, which the mobile app's web view will not download.
export const downloadCollegeCounsellingRecommendationWord = (id, data, onSuccess, onFailure) => {
  return {
    type: DOWNLOAD_COLLEGE_COUNSELLING_RECOMMENDATION_WORD,
    payload: {
      apiUrl: constants.api_college_counselling_recommendation_letter(id),
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: {...data, format: 'word'},
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const downloadCollegeCounsellingRecommendation = (id, data, onSuccess, onFailure) => {
  return {
    type: DOWNLOAD_COLLEGE_COUNSELLING_RECOMMENDATION,
    payload: {
      apiUrl: constants.api_college_counselling_recommendation_letter(id),
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const submitCollegeCounsellingRecommendation = (id, data, onSuccess, onFailure) => {
  return {
    type: SUBMIT_COLLEGE_COUNSELLING_RECOMMENDATION,
    payload: {
      apiUrl: constants.api_college_counselling_recommendation(id),
      getString: '',
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const saveCollegeCounsellingRecommendationDraft = (id, data, onSuccess, onFailure) => {
  return {
    type: SAVE_COLLEGE_COUNSELLING_RECOMMENDATION_DRAFT,
    payload: {
      apiUrl: constants.api_college_counselling_recommendation_draft(id),
      getString: '',
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getCollegeCounsellingPortfolio = (id, onSuccess, onFailure) => {
  return {
    type: GET_COLLEGE_COUNSELLING_PORTFOLIO,
    payload: {
      apiUrl: constants.api_college_counselling_portfolio(id),
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getCollegeCounsellingPortfolios = (data, onSuccess, onFailure) => {
  return {
    type: GET_COLLEGE_COUNSELLING_PORTFOLIOS,
    payload: {
      apiUrl: constants.api_college_counselling_portfolios,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const deleteCollegeCounsellingPortfolio = (id, onSuccess, onFailure) => {
  return {
    type: DELETE_COLLEGE_COUNSELLING_PORTFOLIO,
    payload: {
      apiUrl: constants.api_college_counselling_portfolio(id),
      getString: '',
      useBaseURL: true,
      requestType: 'DELETE',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const returnCollegeCounsellingPortfolio = (id, data, onSuccess, onFailure) => {
  return {
    type: RETURN_COLLEGE_COUNSELLING_PORTFOLIO,
    payload: {
      apiUrl: constants.api_college_counselling_return_portfolio(id),
      getString: '',
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const setCollegeCounsellingPortfolioStatus = (id, data, onSuccess, onFailure) => {
  return {
    type: SET_COLLEGE_COUNSELLING_PORTFOLIO_STATUS,
    payload: {
      apiUrl: constants.api_college_counselling_portfolio_status(id),
      getString: '',
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const saveCollegeCounsellingSection = (data, onSuccess, onFailure) => {
  return {
    type: SAVE_COLLEGE_COUNSELLING_SECTION,
    payload: {
      apiUrl: constants.api_college_counselling_save_section,
      getString: '',
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const saveCollegeCounsellingDestinations = (data, onSuccess, onFailure) => {
  return {
    type: SAVE_COLLEGE_COUNSELLING_DESTINATIONS,
    payload: {
      apiUrl: constants.api_college_counselling_save_destinations,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const saveCollegeCounsellingAcademics = (data, onSuccess, onFailure) => {
  return {
    type: SAVE_COLLEGE_COUNSELLING_ACADEMICS,
    payload: {
      apiUrl: constants.api_college_counselling_save_academics,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getCollegeCounsellingDocumentTypes = (onSuccess, onFailure) => {
  return {
    type: GET_COLLEGE_COUNSELLING_DOCUMENT_TYPES,
    payload: {
      apiUrl: constants.api_college_counselling_document_types,
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const saveCollegeCounsellingDocument = (data, onSuccess, onFailure) => {
  return {
    type: SAVE_COLLEGE_COUNSELLING_DOCUMENT,
    payload: {
      apiUrl: constants.api_college_counselling_save_document,
      getString: '',
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const deleteCollegeCounsellingDocument = (id, onSuccess, onFailure) => {
  return {
    type: DELETE_COLLEGE_COUNSELLING_DOCUMENT,
    payload: {
      apiUrl: constants.api_college_counselling_delete_document(id),
      getString: '',
      useBaseURL: true,
      requestType: 'DELETE',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const submitCollegeCounsellingPortfolio = (data, onSuccess, onFailure) => {
  return {
    type: SUBMIT_COLLEGE_COUNSELLING_PORTFOLIO,
    payload: {
      apiUrl: constants.api_college_counselling_submit,
      getString: '',
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

// The whole submitted application as one PDF, attachments merged in. Same
// {url} contract as the recommendation letter: the API uploads the file and
// hands back a link, which the page opens.
export const downloadCollegeCounsellingApplicationPdf = (id, data, onSuccess, onFailure) => {
  return {
    type: DOWNLOAD_COLLEGE_COUNSELLING_APPLICATION_PDF,
    payload: {
      apiUrl: constants.api_college_counselling_application_pdf(id),
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
